import { Map, fromJS } from 'immutable';

import * as constAction from 'root/actionConstants';

const definedDuration = 2000;

const defaultState = Map({
  notificacion: Map(),
  dashboard: Map({
    'titulo': 'JAITS'
  }),
  loadingbar: Map(),
  snackbar: Map({
    open: false,
    message: ''
  }),
  seleccionador: Map({
    listas: Map(),
    open: false
  })
});

export default function reducer(
  state=defaultState, action) {
    switch (action.type) {
      case constAction.CONTRASENA_CAMBIADA:{
        return state.set('notificacion', Map({
          titulo: 'Te hemos enviado un email',
          subtitulo: 'Dentro veras un link para cambiar tu contraseña',
          texto: 'Recueda buscar en en la bandeja de correo no deseado si no lo encuentras'
        }));
      }
      case constAction.DASHBOARD_CHANGE_TITLE:{
        return state.setIn(['dashboard', 'titulo'], action.payload);
      }
      case constAction.LOADINGBAR_SHOW:{
        let count = state.getIn(['loadingbar', 'count']);
        count = count ? count + 1 : 1;
        return state.setIn(['loadingbar', 'show'], true).setIn(['loadingbar', 'count'], count);
      }
      case constAction.LOADINGBAR_HIDE:{
        let count = state.getIn(['loadingbar', 'count']);
        if(count >= 1){
          count = count - 1;
          return state.setIn(['loadingbar', 'count'], count).setIn(['loadingbar', 'show'], count >= 1 ? true : false);
        }else return state.setIn(['loadingbar', 'show'], false);
      }
      case constAction.SNACKBAR_SHOW:{
        return state.setIn(['snackbar', 'open'], true).setIn(['snackbar', 'message'], action.payload.message).setIn(['snackbar', 'duration'], action.payload.duration ? action.payload.duration : definedDuration);
      }
      case constAction.SNACKBAR_HIDE:{
        return state.setIn(['snackbar', 'open'], false).setIn(['snackbar', 'message'], '').setIn(['snackbar', 'duration'], definedDuration);
      }
      case constAction.SELECCIONADOR_SET_LISTA:{
        return state.setIn(['seleccionador', 'listas', action.payload.nombre], fromJS(action.payload.items));
      }
      case constAction.SELECCIONADOR_CLEAR_LISTA:{
        return state.deleteIn(['seleccionador', 'listas', action.payload.nombre]);
      }
      case constAction.SELECCIONADOR_OPEN:{
          return state.setIn(['seleccionador', 'open'], action.payload.nombre);
      }
      case constAction.SELECCIONADOR_CLOSE:{
          return state.setIn(['seleccionador', 'open'], false);
      }
    }
    return state;
  }



// WEBPACK FOOTER //
// src/modules/general/reducer.js